module.exports = __webpack_public_path__ + "img/Overview_02_timeline_v2.08f9eea6.jpg";